export default {
    acc: 'https://acc.mrbilit.ir',
    auth: 'https://auth.mrbilit.ir',
    bill: 'https://bill.mrbilit.ir',
    bundle: 'https://bundle.mrbilit.ir',
    bus: 'https://bus.mrbilit.ir',
    content: 'https://content.mrbilit.ir',
    coupon: 'https://coupon.mrbilit.ir',
    faas: 'https://faas.mrbilit.net/function',
    finalize: 'https://finalize.mrbilit.ir/api',
    flight: 'https://flight.atighgasht.com',
    forecast: 'https://forecast.mrbilit.ir',
    giftCard: 'https://giftcard.mrbilit.ir/',
    hotel: 'https://hotel.mrbilit.ir',
    notifier: 'https://notifier.mrbilit.ir',
    payment: 'https://payment.mrbilit.ir',
    priceTrack: 'https://pricetrack.mrbilit.ir',
    tracking: 'https://errortracking.mrbilit.net',
    train: 'https://train.mrbilit.com',
    flightInfo: 'https://flightinfo.mrbilit.ir',
    userLog: 'https://user-log.mrbilit.ir',
    workflow: 'https://workflow.mrbilit.ir',
};
